export enum LayoutIds
{
  MODAL  = 'modal',
  TAB    = 'tab',
  INLINE = 'inline'
}
